import React, { useEffect, useState, useRef } from "react";
import Ceo from "./../../assets/ceo.webp";
import Fceo from "./../../assets/fceo1.webp";
import Emp1 from "./../../assets/emp1.webp";
import Emp2 from "./../../assets/emp2.webp";
import Emp3 from "./../../assets/emp3.webp";
import Emp4 from "./../../assets/Industries/dynaspeed/WhatsApp Image 2025-05-03 at 11.30.12 AM.jpeg";
import Emp5 from "./../../assets/Industries/dynaspeed/IMG_20250502_155731.jpg";

const teamMembers = [
  { name: "K.Senthila", role: "Senior Engineer", image: Emp1 },
  { name: "Vinitha", role: "Junior Architect", image: Emp2 },
  { name: "Marshal John", role: "Junior Architect", image: Emp3 },
  { name: "Saambavi.V", role: "Junior Engineer", image: Emp4 },
  { name: "M.Vetri Selvi", role: "Junior Architect", image: Emp5 },
];

export default function AboutUs() {
  const [animate, setAnimate] = useState(false);
  const sectionRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        gridTemplateColumns: "1fr",
        textAlign: "center",
        textAlign1: "center",
        fontSizeTitle: "22px",
        fontSizeSubtitle: "18px",
        fontSizeText: "14px",
        imageWidth: "90%",
        imageMargin: "10px 0",
      };
    } else if (windowWidth <= 1000) {
      return {
        gridTemplateColumns: "1fr",
        textAlign: "center",
        textAlign1: "center",
        fontSizeTitle: "28px",
        fontSizeSubtitle: "20px",
        fontSizeText: "15px",
        imageWidth: "70%",
        imageMargin: "0",
      };
    }
    return {
      gridTemplateColumns: "1fr 1fr",
      textAlign: "left",
      textAlign1: "right",
      fontSizeTitle: "34px",
      fontSizeSubtitle: "24px",
      fontSizeText: "16px",
      imageWidth: "60%",
      imageMargin: "0",
    };
  };

  const styles = getResponsiveStyles();

  return (
    <div ref={sectionRef} style={{ width: "100%", margin: "auto", padding: styles.padding, position: "relative" }}>
      {/* About Section */}
      <section style={{ textAlign: "center", opacity: animate ? 1 : 1, transform: "translateX(0px)", transition: "all 0.8s ease-out 0.3s" }}>
        <h2 style={{ fontSize: styles.fontSizeTitle, fontWeight: "bold" }}>Welcome to Our Company</h2>
        <p style={{ color: "gray", marginTop: "8px", marginBottom: "30px" }}>
          We are dedicated to providing top-notch services to our clients with a team of experienced professionals.
        </p>
      </section>

      {/* Founder and Future Leader Section */}
      <section
        style={{
          display: "grid",
          gridTemplateColumns: styles.gridTemplateColumns,
          gap: "16px",
          alignItems: "center",
          opacity: animate ? 1 : 1,
          transition: "all 0.8s ease-out 0.3s",
          padding: "20px",
        }}
      >
        {/* Founder */}
        <div style={{ textAlign: "center" }}>
          <img
            src={Ceo}
            alt="Founder"
            style={{
              width: styles.imageWidth,
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              margin: styles.imageMargin,
            }}
          />
        </div>
        <div style={{ textAlign: styles.textAlign }}>
          <h2 style={{ fontSize: styles.fontSizeTitle, fontWeight: "bold", color: "#5c0e14" }}>Er. G. Samson Sundaram, B.E</h2>
          <h3 style={{ fontSize: styles.fontSizeSubtitle, color: "grey" }}>Founder and CEO</h3>
          <p style={{ fontSize: styles.fontSizeText, lineHeight: "1.5rem" }}>
            <strong>About Mr. Samson Sundaram</strong>
            <br />
            <strong>A Legacy of Vision, Innovation & Excellence</strong>
            <br />
            <br />
            For over <strong>50 years</strong>, Mr. Samson Sundaram has been a <strong>Pioneering Architect and Engineer</strong>, shaping the landscape of <strong>Hosur’s architectural sector</strong>.
            As the <strong>Founder of Samson and Associates</strong>, he has led the firm in delivering <strong>Iconic, Sustainable, and Innovative Architectural Solutions</strong> across <strong>Industrial, Residential, and Commercial Projects</strong>.
            His expertise in <strong>Modern Architecture, Structural Engineering, and Interior Design</strong> has positioned the firm as a <strong>Leading Architectural Consultancy in Tamil Nadu</strong>.
            <br />
            <br />
            Under his leadership, <strong>Samson and Associates</strong> has expanded its presence across <strong>Hosur, Chennai, and Beyond</strong>, creating <strong>Aesthetic, Functional, and Eco-Friendly Spaces</strong> that stand the test of time.
            With a focus on <strong>Sustainable Architecture, Energy-Efficient Buildings, and Cutting-Edge Design Principles</strong>, the firm continues to set benchmarks in <strong>Architectural Excellence</strong>.
            <br />
            <br />
            Driven by a passion for <strong>Transforming Urban and Industrial Landscapes</strong>, Mr. Sundaram’s work remains a testament to <strong>Quality, Durability, and Innovation in Architecture</strong>.
            His leadership inspires a new era of <strong>Architectural and Engineering</strong> solutions that redefine <strong>Modern Living Spaces in India</strong>.
          </p>
        </div>
      </section>

      {/* Future Leader Section - Column Reverse on Large Screens */}
      <div
        style={{
          display: "flex",
          flexDirection: windowWidth > 1000 ? "row-reverse" : "column",
          alignItems: "center",
          gap: "16px",
          padding: "20px",
          transition: "all 0.8s ease-out 0.3s",
        }}
      >
        <div style={{ textAlign: "center", flex: "1" }}>
          <img
            src={Fceo}
            alt="Future CEO"
            style={{
              width: styles.imageWidth,
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              margin: styles.imageMargin,
            }}
          />
        </div>
        <div style={{ textAlign: styles.textAlign1, flex: "1" }}>
          <h2 style={{ fontSize: styles.fontSizeTitle, fontWeight: "bold", color: "#5c0e14" }}>Ar. Priya Vinoth, M.Arch</h2>
          <h3 style={{ fontSize: styles.fontSizeSubtitle, color: "grey" }}>Future Leader</h3>
          <p style={{ fontSize: styles.fontSizeText, lineHeight: "1.5rem" }}>
            <strong>About Priya Vinoth:</strong>
            <br />
            <strong>A Visionary in Architecture & Interior Design</strong>
            <br />
            <br />
            Mrs. <strong>Priya Vinoth</strong>, daughter of Mr. <strong>Samson Sundaram</strong>, is a highly accomplished <strong>Architect and Interior Designer</strong> with extensive experience in <strong>Residential, Commercial, and Institutional Projects</strong>.
            She holds a <strong>Master of Architecture (M.Arch) in Interior Design</strong> from <strong>Jawaharlal Nehru Technological University (JNTU), Hyderabad</strong>, and is a <strong>Registered Architect</strong> with the <strong>Council of Architecture (CA/2008/41668)</strong>.
            <br />
            <br />
            With a passion for <strong>Innovative Interior Design and Sustainable Architecture</strong>, Ar. Priya has successfully delivered <strong>High-End Residential, Commercial, and Industrial Projects</strong> under the mentorship of renowned architects in <strong>Bangalore and Chennai</strong>.
            Her expertise spans <strong>Architectural Planning, Interior Detailing, and Spatial Design</strong>, ensuring every project reflects <strong>Functionality, Aesthetics, and Sustainability</strong>.
            <br />
            <br />
            <strong>Global Experience & Expertise</strong>
            <br />
            During her tenure in the <strong>United States</strong>, Ar. Priya collaborated with <strong>Pastor Art Webb</strong> in <strong>Charlotte, North Carolina</strong>, where she led the <strong>Architectural Design of Retirement Homes for Senior Citizens</strong> and various high-end <strong>Residential Projects</strong>.
            Her exposure to <strong>International Architectural Trends and Interior Design Standards</strong> has allowed her to bring a <strong>Global Perspective</strong> to her projects in <strong>India</strong>.
            <br />
            <br />
            Currently, <strong>Ar. Priya Vinoth</strong> plays a key role at <strong>Samson and Associates</strong>, where she merges <strong>Modern Architectural Trends</strong> with <strong>Timeless Design Principles</strong>.
            She has been instrumental in shaping <strong>Luxury Residential Interiors, Corporate Workspaces, and Industrial Architecture</strong> across <strong>Hosur, Chennai, and Beyond</strong>.
            Her ability to integrate <strong>Sustainable Building Materials, Eco-Friendly Design Solutions, and Contemporary Aesthetics</strong> makes her one of the leading <strong>Interior Architects in Tamil Nadu</strong>.
          </p>
        </div>
      </div>

      {/* Team Section */}
      <section
        style={{
          textAlign: "center",
          marginTop: "24px",
          opacity: animate ? 1 : 1,
          transition: "all 0.8s ease-out 0.6s",
        }}
      >
        <h2 style={{ fontSize: styles.fontSizeSubtitle, fontWeight: "bold" }}>Meet Our Team</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: windowWidth <= 480 ? "1fr" : "repeat(3, 1fr)",
            gap: "16px",
            marginTop: "16px",
            padding: "20px",
          }}
        >
          {teamMembers.map((member, index) => (
            <div
              key={index}
              style={{
                background: "white",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                opacity: animate ? 1 : 1,
                transition: `all 0.8s ease-out ${0.8 + index * 0.2}s`,
              }}
            >
              <img
                src={member.image}
                alt={member.name}
                style={{
                  width: "80px",
                  height: "80px",
                  display: "block",
                  margin: "auto",
                  borderRadius: "50%",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              />
              <h3 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "8px" }}>{member.name}</h3>
              <p style={{ color: "gray" }}>{member.role}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
